export const COMPARE_PLANS_SCROLL_ID = 'compare-plans-scroll-target';
